export const NAME_AND_CITY_NOT_ALLOWED_SYMBOLS = /[.\\~`!@#$£±%^&*()_+={}/?|:;"<>,\][]/;
export const ADDRESS_NOT_ALLOWED_SYMBOLS = /[\\~`!@$£±%^*_={}?|:;"<>\][]/;
export const WHITE_START_OR_END_REGEXP = /(?:^\s+\S*)|(?:\S*\s+$)/;
export const START_WITH_LETTER_REGEXP = /^[A-Za-z]/;
export const CONTAIN_UPPERCASE_LETTER_REGEXP = /[A-Z]/;
export const CONTAIN_LOWERCASE_LETTER_REGEXP = /[a-z]/;
export const CONTAIN_LETTER_REGEXP = /[A-Za-z]/;
export const CONTAIN_SYMBOL_REGEXP = /[^A-Za-z\s\d\w]/;
export const CONTAIN_NUMBER_REGEXP = /[0-9]/;
export const NUMBERS_OR_SPACE = /^(?=.\d[\d]+$)/;
export const NUMBERS_ONLY_REGEXP = /^\d+$/;
export const NUMBERS_ONLY_DECIMALS_ALLOWED = /^\d+(\.\d{1,2})?$/;
export const START_WITH_BANNED_WORDS =
  /^(host|moderator|Accts|Cnslt|CSR|DAD|FPP|Host|HR|IT|Mgmt|Mktg|Pmts|Soft|Staff|Support|psdeadbl|Tilter|CAGE|DGE)/i;
export const PO_BOX_ADDRESS_REGEX = /(\bp[.\s\\/]*[box]+[.\s]*\b)|\bbx\b|\bbox\b/i;
export const CONTAIN_SPECIAL_CHARACTER_REGEXP = /[^\x20-\x7F]+/;
export const CONTAIN_LATIN_CHARACTERS_ONLY = /[^\x20-\x7FÀ-ÿ]+/;
export const CONTAIN_INT_AND_DEC_NUMBERS = /^[+-]?\d+(\.\d+)?$/;
export const CONTAIN_LATIN_AND_SPANISH_CHARACTERS_ONLY =
  /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\u00F1\u00D1'_:-]+$/u;
export const RESTRICTED_SYMBOLS_SHORT = /[{}<>=]/;
export const SPACE_BETWEEN_CHAR_AND_INT = /\d[^\d\s]|[^\d\s]\d/;
export const CANADIAN_ZIP_CODE_FORMAT = /[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/;
export const USER_ID_FRANCE_REGEX = /[^A-Za-z0-9+_/]+/;
export const IBAN_VALIDATION = /^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/;
export const NIF_REGEX = /^\d{9}$/;
export const CPR_REGEX = /^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])\d{2}\d{4}$/;
export const DNI_CONTROL_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKE';
export const DNI_REGEX = /^\d{8}[A-Z]$/;
export const NIE_REGEX = /^[XYZ][\d]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
export const GERMANY_STREET_NAME_ALLOWED_CHARACTERS =
  /^[\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff\u0100-\u017f\u00aa\u00b7\u00ba\u002e\u002d\u00b4\u0060\u0027a-zA-Z0-9\s]*$/i;
export const GERMANY_STREET_NAME_VALID_CHARACTERS =
  /[\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff\u0100-\u017f\u00aa\u00b7\u00ba\u002e\u002d\u00b4\u0060\u0027A-Za-z0-9]/g;
export const GERMANY_BUILDING_NUMBER_ALLOWED_CHARACTERS =
  /^[\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff\u0100-\u017f\u00aa\u00b7\u00ba\u002d\u002fa-zA-Z0-9\s]*$/i;
export const GERMANY_BUILDING_NUMBER_VALID_CHARACTERS =
  /[\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff\u0100-\u017f\u00aa\u00b7\u00ba\u002d\u002fA-Za-z0-9]/g;
export const GERMANY_CITY_ALLOWED_CHARACTERS =
  /^[\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff\u0100-\u017f\u00aa\u00b7\u00ba\u002e\u002d\u00b4\u0060\u0027\u002f\u0028\u0029a-zA-Z\s]*$/i;
export const GERMANY_CITY_VALID_CHARACTERS =
  /[\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff\u0100-\u017f\u00aa\u00b7\u00ba\u002e\u002d\u00b4\u0060\u0027\u002f\u0028\u0029A-Za-z]/g;
export const GERMANY_NAME_ALLOWED_CHARACTERS =
  /^[\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff\u0100-\u017f\u00aa\u00b7\u00ba\u002e\u002d\u00b4\u0060\u0027a-zA-Z\s]*$/i;
export const GERMANY_NAME_VALID_CHARACTERS =
  /[\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff\u0100-\u017f\u00aa\u00b7\u00ba\u002e\u002d\u00b4\u0060\u0027A-Za-z]/g;
export const NO_CONSECUTIVE_HYPHENS = /-{2}/;
export const NO_CONSECUTIVE_SPACES = /\s{2}/;
export const PORTUGAL_STREET_ADDRESS_ALLOWED_CHARACTERS =
  /^[a-zA-Z0-9\u00C0\u00C2\u00C4\u00C7\u00C9\u00C8\u00CA\u00CB\u00CE\u00CF\u00D4\u00D6\u00D9\u00DB\u00DC\u0178\u00E0\u00E2\u00E4\u00E7\u00E9\u00E8\u00EA\u00EB\u00EE\u00EF\u00F4\u00F6\u00F9\u00FB\u00FC\u00FF\u00C6\u0152\u00E6\u0153:'\u00E3\u00C3\u00C1\u00E1\u00CC\u00CD\u00EC\u00ED\u00D2\u00D3\u00D5\u00F2\u00F3\u00F5\u00DA\u00FA\u00D1\u00F1 -]*$/i;
export const PORTUGAL_STREET_ADDRESS_VALID_CHARACTERS =
  /[a-zA-Z0-9\u00C0\u00C2\u00C4\u00C7\u00C9\u00C8\u00CA\u00CB\u00CE\u00CF\u00D4\u00D6\u00D9\u00DB\u00DC\u0178\u00E0\u00E2\u00E4\u00E7\u00E9\u00E8\u00EA\u00EB\u00EE\u00EF\u00F4\u00F6\u00F9\u00FB\u00FC\u00FF\u00C6\u0152\u00E6\u0153:'\u00E3\u00C3\u00C1\u00E1\u00CC\u00CD\u00EC\u00ED\u00D2\u00D3\u00D5\u00F2\u00F3\u00F5\u00DA\u00FA\u00D1\u00F1 -]/g;
